interface ProductIconProps {
  size?: number;
}

/**
 * Chatbot product icon — chat bubble containing the canonical Spark mark.
 * Fixed-color app icon treatment: always Midnight bg (#0A0E1A), Frost fg (#E2E8F0).
 */
export function ProductIcon({ size = 28 }: ProductIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Midnight background */}
      <rect width="32" height="32" rx="7" fill="#0A0E1A" />

      {/* Chat bubble — rounded rect with a left-anchored tail */}
      {/* Body: x 5–27, y 4–21 (22 × 17). Tail: from (8.5,21) down to (7,26) and (13,21). */}
      <path
        d="M8.5 4L23.5 4Q27 4 27 7.5L27 17.5Q27 21 23.5 21L13 21L7 26L8.5 21Q5 21 5 17.5L5 7.5Q5 4 8.5 4Z"
        fill="#E2E8F0"
        fillOpacity="0.08"
        stroke="#E2E8F0"
        strokeWidth="1.3"
        strokeOpacity="0.72"
        strokeLinejoin="round"
      />

      {/* Spark — two concentric circles as the bot's core, centred in bubble body */}
      <circle cx="16" cy="12.5" r="4.5" fill="none" stroke="#E2E8F0" strokeWidth="1.3" opacity="0.32" />
      <circle cx="16" cy="12.5" r="2.2" fill="#E2E8F0" />
    </svg>
  );
}
